import {Injectable} from '@angular/core';

@Injectable()
export class ScrollToService {
    constructor() {
    }

    scrollTo(target: any): void {
        if (target) {
            const element = $(target).offset();
            if (element) {
                $('html,body').animate({ scrollTop: element.top }, 'fast', () => {
                  target.focus();
                });
            }
        }
    }

    scrollToFirstError(): void {
        let target = $('.invalid:first');
        if (!target.length) {
            target = $('.ng-invalid:not(form):first');
        }
        this.scrollTo(target);
    }

    scrollToFirstErrorForStepRequeteInDepotRequete(): void {
        let target = $('.ng-invalid:not(form):first');
        this.scrollTo(target);
    }

    scrollToNearestTitleOfFirstError(): void {
        let target = $('.invalid:first');
        let closesth5 = target.closest('jhi-section').find('h5');
        let closesth2 = target.closest('jhi-section').find('h2');
        let finalTarget = closesth5.length ? closesth5 : closesth2;
        if (!target.length) {
            target = $('.ng-invalid:not(form):first');
            closesth5 = target.closest('jhi-section').find('h5');
            closesth2 = target.closest('jhi-section').find('h2');
            finalTarget = closesth5.length ? closesth5 : closesth2;
        }
        this.scrollTo(finalTarget);
    }

    scrollBySelector(selector: string): void {
        let target = $(selector);
        this.scrollTo(target);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/scroll-to.service.ts